export default __webpack_public_path__ + "assets/images/e18fd152d5f9c80252568de297673abc.png";